import React from "react";
import VerticalTabs from "../../common/VerticalTabs";
import Serialization from "./serialization/Index";
import Contracts from "./contracts/Index";
import { RepoProvider } from "./contracts/ContractContext";

const tabs = [
  {
    id: "contracts",
    label: "Contracts",
    component: Contracts,
  },
  {
    id: "serialization",
    label: "Serialization",
    component: Serialization,
  },
];

const Index: React.FC = () => {
  return (
    <RepoProvider>
      <VerticalTabs tabs={tabs} title="Utility Tools" />
    </RepoProvider>
  );
};

export default Index;
